module.exports = __webpack_public_path__ + "static/media/scoliosis_mild_right.88799259.png";